<template>
	<div class="order-detail-body">
		<div class="order-detail-header">
			<img src="~/images/icon/position.png" alt="" class="position">
			<div class="my-position">您的位置：</div>
			<el-breadcrumb separator-class="el-icon-arrow-right">
				<el-breadcrumb-item>
					<span class="go-back-span" @click="goBack('all')">退单</span>
				</el-breadcrumb-item>
				<el-breadcrumb-item>
					<span class="go-back-span" @click="goBack('single')">{{orderstatusName}}</span>
				</el-breadcrumb-item>
				<el-breadcrumb-item>退单详情</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class="order-detail-info">
			<div class="info-left">
				<div class="info-left-container">
					<DetailInfo
						:showBtn1='orderstatus === 0 && AuthorityList["07_0002_0003_00"]'
						:showBtn2='orderstatus === 1 && AuthorityList["07_0002_0009_00"]'
						:showBtn3='!(detailData.cause === 6 || detailData.cause === 7) && (pushstate === "2" || pushstate === "0") && orderstatus === 3 && matchbillcenterflag === 1 && AuthorityList["07_0002_0009_00"]'
						:detailData='detailData'/>
					<!-- <Arbitrationinfo v-if="(orderstatus === 1 || orderstatus === 2 || orderstatus === 3) && showArbitrationinfo" class="arbitrationinfo-div" :Arbitrationinfo='Arbitrationinfo' /> -->
					<GoodsInfo
						:goodData='goodData'
						:deliveryData='deliveryData'
						:autoflag='autoflag'
						:orderstatusName='orderstatusName'/>
				</div>
				<div class="info-btn">
					<el-button class="btn" style="float:right" size="small" v-if='!(detailData.cause === 6 || detailData.cause === 7) && (pushstate === "2" || pushstate === "0") && orderstatus === 3 && matchbillcenterflag === 1 && AuthorityList["07_0002_0009_00"]' @click='pullClick' plain type="primary">手动同步云数据</el-button>
				</div>
			</div>
			<div class="info-right">
				<DeliveryInfo :deliveryData='deliveryData'/>
			</div>
			<el-dialog
			title="拒绝原因"
			:visible.sync="rejectModal"
			:close-on-click-modal="false"
			class="dialog-title"
			width="400px"
			>
				<div class="radio">
					<el-radio v-model="cancelcause" :label="1">质量无问题</el-radio>
				</div>
				<div class="radio">
					<el-radio v-model="cancelcause" :label="2">超出退货时间</el-radio>
				</div>
				<div class="radio">
					<el-radio v-model="cancelcause" :label="3">问题已解决</el-radio>
				</div>
				<div class="radio">
					<el-radio v-model="cancelcause" :label="4">该商品不符合无理由退货</el-radio>
				</div>
				<div class="radio">
					<el-radio v-model="cancelcause" :label="5">影响二次销售</el-radio>
				</div>
				<div class="radio">
					<el-radio v-model="cancelcause" :label="6">其他原因</el-radio>
				</div>
				<el-input @change='othercauserChange' style="margin-bottom: 10px;" :maxlength="50" :disabled="cancelcause !== 6" type="textarea" v-model="othercauser"></el-input>
				<span slot="footer" class="dialog-footer">
					<el-button class="fx-big-btn" type="primary" plain size='small' @click="cancel">取 消</el-button>
					<el-button class="fx-big-btn" type="primary" plain size='small' @click="save">确 定</el-button>
				</span>
			</el-dialog>
		</div>
	</div>
</template>

<script>
import DetailInfo from '@/views/index/src/refundorderdetailDock/DetailInfo.vue'
import GoodsInfo from '@/views/index/src/refundorderdetailDock/GoodsInfo.vue'
import DeliveryInfo from '@/views/index/src/refundorderdetailDock/DeliveryInfo.vue'
export default {
	name: 'orderDetail',
	components: {
		DetailInfo,
		GoodsInfo,
		DeliveryInfo
	},
	data () {
		return {
			autoflag: false,
			othercauser: '',
			showArbitrationinfo: false,
			Arbitrationinfo: {
				verifyResult: null,
				applyDate: '',
				verifyDate: '',
				adminLoginName: '',
				verifyReason: ''
			},
			refundId: '',
			pusherrorreson: '',
			pushstate: null,
			orderstatusName: '',
			cancelcause: 1,
			rejectModal: false,
			orderstatus: null,
			refundstatusid: null,
			refundway: null,
			shopName: '',
			detailData: {
				ordernumber: null,
				refundstatus: null,
				refundMethod: null,
				refundway: null,
				cause: null,
				orderstatus: null,
				memo: null,
				refundImgs: null,
				createdate: null,
				liquidateflag: null
			},
			deliveryData: {
				ordernumber: null,
				ob_btel: null,
				ob_storename: null,
				os_entname: null,
				ob_name: null,
				createdate: null,
				fulfillment: null,
				ob_address: null,
				os_organid: null
			},
			AuthorityList: {
				'07_0002_0001_00': false,
				'07_0002_0002_00': false,
				'07_0002_0003_00': false,
				'07_0002_0004_00': false,
				'07_0002_0005_00': false,
				'07_0002_0006_00': false,
				'07_0002_0007_00': false,
				'07_0002_0008_00': false,
				'07_0002_0009_00': false,
				'07_0002_0010_00': false,
				'07_0002_0011_00': false,
				'07_0002_0012_00': false,
				'07_0002_0013_00': false,
				'07_0002_0014_00': false,
				'07_0002_0015_00': false
			},
			goodData: [],
			params: {},
			matchbillcenterflag: 0
		}
	},
	created () {
		this.$fxEventBus.$emit('setMenu', '6-2')
		this.getAuthority('07_0002_0000_00')
		let a = window.sessionStorage.getItem('refundOrderParams')
		this.params = JSON.parse(a)
		this.checkSmallCategory()
		this.getInfo()
	},
	methods: {
		othercauserChange () {
			this.othercauser = this.othercauser.trim()
			this.othercauser = this.othercauser.replace(/[',\\]/g, '')
		},
		// 是否开启小类
		checkSmallCategory () {
			// return new Promise((resolve, reject) => {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/systemcenter/matchorganinfo/checkSmallCategoryIsUser`
			}).then(res => {
				this.matchbillcenterflag = res.matchbillcenterflag
			})
			// })
		},
		pullClick () {
			let params = {
				statusid: this.refundstatusid,
				refundorderid: this.refundId
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/match/handPushRefundOrderToOtherPlatform`,
				data: params
			}).then(res => {
				if (res.result) {
					this.$message.success('同步成功')
				} else {
					this.$message.error(res.msg)
				}
				this.getInfo()
			})
		},
		getAuthority (data) {
			let params = {
				pId: data
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getUserAuthority`,
				data: params
			}).then(res => {
				if (res.result === true) {
					let a = res.data
					for (let i = 0; i < a.length; i++) {
						this.AuthorityList[a[i]] = true
					}
				}
			})
		},
		goBack (data) {
			let a = JSON.parse(window.sessionStorage.getItem('refundTab'))
			if (data === 'all') {
				a.active = '全部退单'
				a.orderStatus = this.orderstatus
			} else {
				a.active = this.orderstatusName
				a.orderStatus = this.orderstatus
			}
			window.sessionStorage.setItem('refundTab', JSON.stringify(a))
			this.$router.push('/dock/refundOrder')
		},
		cancel () {
			this.rejectModal = false
		},
		save () {
			this.btnClick(2)
		},
		reject () {
			this.rejectModal = true
			this.cancelcause = 1
		},
		btnClick (data) {
			let params = {
				action: data,
				refundstatus: this.orderstatus,
				refundstatusid: this.refundstatusid,
				refundway: this.refundway
			}
			if (data === 2) {
				params.cancelcause = this.cancelcause
				params.memo = this.othercauser
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/refundorder/updateRefundStatus`,
				data: params
			}).then(res => {
				if (res.result === true) {
					this.$message.success('操作成功！')
					this.rejectModal = false
					this.getInfo()
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		changeName () {
			switch (this.orderstatus) {
			case 0:
				this.orderstatusName = '待处理'
				break
			case 1:
				this.orderstatusName = '已同意'
				break
			case 2:
				this.orderstatusName = '已拒绝'
				break
			case 3:
				this.orderstatusName = '退货完成'
				break
			}
		},
		getInfo () {
			let params = {
				refundorderid: this.params.refundid,
				messageid: this.params.messageId || ''
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/refundorder/getdetail/`,
				data: params
			}).then(res => {
				if (res.result === true) {
					this.autoflag = res.data.autoflag
					this.refundId = res.data.refundId
					this.pushstate = res.data.pushstate
					this.pusherrorreson = res.data.pusherrorreson
					this.shopName = res.data.seller.os_shopname
					this.orderstatus = res.data.orderstatus
					this.refundway = res.data.refundway
					this.refundstatusid = res.data.statusid
					let addr = ''
					if (res.data.buyer.ob_address.indexOf('{"detail') > 0) {
						let acceptAddr1 = res.data.buyer.ob_address.slice(0, res.data.buyer.ob_address.indexOf('{"detail'))
						let acceptAddr2 = res.data.buyer.ob_address.slice(res.data.buyer.ob_address.indexOf('{"detail'))
						addr = acceptAddr1 + JSON.parse(acceptAddr2).detail + JSON.parse(acceptAddr2).local
					} else {
						addr = res.data.buyer.ob_address
					}
					if (res.data.arbitrationinfo !== null) {
						this.showArbitrationinfo = true
						this.Arbitrationinfo = {
							verifyResult: res.data.arbitrationinfo.verifyResult,
							applyDate: res.data.arbitrationinfo.applyDate,
							verifyDate: res.data.arbitrationinfo.verifyDate,
							adminLoginName: res.data.arbitrationinfo.adminLoginName,
							verifyReason: res.data.arbitrationinfo.verifyReason
						}
					}
					this.detailData = {
						autorefundflag: res.data.autorefundflag,
						sourcetype: res.data.sourcetype,
						totalprice: res.data.totalprice,
						refundPayId: res.data.refundPayId,
						refundId: res.data.refundId,
						orderId: res.data.order.orderId,
						refundstatus: res.data.refundstatus,
						cancelcause: res.data.cancelcause,
						ordernumber: res.data.ordernumber,
						refundImgs: res.data.refundImgs,
						refundMethod: res.data.refundMethod,
						refundway: res.data.refundway,
						cause: res.data.cause,
						orderstatus: res.data.orderstatus,
						memo: res.data.memo,
						createdate: res.data.createdate,
						liquidateflag: res.data.liquidateflag,
						othercauser: res.data.othercauser
					}
					this.deliveryData = {
						customerCategoryName: res.data.customerCategoryName,
						customerName: res.data.customerName,
						refundid: this.params.refundid,
						ordernumber: res.data.order.ordernumber,
						ob_btel: res.data.buyer.ob_btel,
						ob_storename: res.data.buyer.ob_storename,
						ob_entname: res.data.buyer.ob_entname,
						ob_name: res.data.buyer.ob_name,
						createdate: res.data.order.createdate,
						ob_address: addr,
						fulfillment: res.data.fulfillment,
						isSellerpull: res.data.order.isSellerpull !== 0,
						billState: res.data.order.billState,
						buypullstate: res.data.order.buypullstate,
						orderId: res.data.order.orderId,
						statusId: res.data.order.statusid,
						differ: +res.data.order.differ,
						sellerShopId: res.data.seller.os_shopid,
						os_organid: res.data.seller.os_organid
					}
					this.goodData = res.data.goodsData
					this.changeName()
				} else {
					this.$message.error(res.msg)
				}
			})
		}
	}
}
</script>

<style lang="stylus" scoped>
.order-detail-body {
	width :100%;
	height:100%;
	min-width :1100px;
	overflow:auto;
	background-color :#ffffff;
	flex: 1
	display flex
	flex-direction column
	.dock-box{
		width :600px;
		text-align:left;
		position: relative;
		line-height :48px;
		height :0px;
		top:-50px;
		left :220px;
		font-size: 13px
	}
	.shop-position {
		display flex
		align-items: center
		height: 50px
		min-height: 50px
		font-size: 14px
		border-bottom: 1px solid #dce1fe
		img {
			display inline-block
			width: 20px
			height: 22px
			margin-right: 10px
		}
	}
	.order-detail-header {
		height:50px;
		line-height:50px;
		text-align:left
		font-size: 16px;
		// border-bottom 1px solid #DCE1FE
		.my-position {
			font-size: 14px;
			display: inline-block;
			position: relative;
			top: -20px;
		}
		.position {
			width: 15px;
			height: 15px;
			float: left;
			margin: 17px 11px 0 9px;
		}
		.el-breadcrumb {
			display inline-block
			height: 49px
			line-height: 49px
			.go-back-span {
				font-weight: 700
				cursor: pointer
			}
		}
	}
	.order-detail-info {
		display flex;
		flex: 1;
		box-sizing :border-box;
		height: calc(100% - 110px);
		.info-left {
			display flex
			flex: 1
			height: 100%
			flex-direction column
			margin-right: 10px
			.info-left-container {
				display flex
				flex: 1
				flex-direction column
				overflow-y auto
			}
			.info-btn {
				padding: 20px
				text-align right
				.btn {
					width :130px;
					height :35px;
					margin-left :20px;
				}
			}
		}
		.info-right {
			display flex
			overflow-y :auto
			box-sizing: border-box
			width: 300px
		}
	}
	.radio{
		text-align :left
		margin :10px 0px 10px 10px
	}
}
</style>
<style lang="stylus">
.order-detail-body {
	.dialog-title {
		text-align: left
		.el-dialog__headerbtn{
			width: 20px;
			height: 20px;
			border-radius: 50%;
			background-color: red;
			line-height: 20px;
			font-weight:blod;
			.el-icon-close{
				color:#fff
			}
		}
	}
	.el-dialog__footer{
		text-align :center
	}
}
</style>
